import { FoodsIcon } from "@foodpilot/foods";
import { Button, Stack, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useActionsContext } from "src/context/Actions/useActionsContext";
import { HeaderActions } from "./HeaderActions";
import { Fragment } from "react/jsx-runtime";

type ListPlanningHeaderProps = {
    isEdit: boolean;
    toggleEdit: () => void;
};
export const ListPlanningHeader = (props: ListPlanningHeaderProps) => {
    const { isEdit, toggleEdit } = props;

    const theme = useTheme();
    const { actionPlanStats } = useActionsContext();

    return (
        <Stack
            flexDirection={"row"}
            gap={theme.spacing(4)}
            sx={{
                justifyContent: "space-between",
                alignItems: "center",
                padding: theme.spacing(3, 4, 3, 4),
            }}
        >
            {actionPlanStats.engagedActions <= 0 ?
                <NoItemsHeader isEdit={isEdit} toggleEdit={toggleEdit} />
            :   <HeaderLine isEdit={isEdit} toggleEdit={toggleEdit} />}
        </Stack>
    );
};

type HeaderLineProps = {
    isEdit: boolean;
    toggleEdit: () => void;
};
const HeaderLine = (props: HeaderLineProps) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const { actionPlanStats } = useActionsContext();
    const { isEdit, toggleEdit } = props;

    return (
        <Fragment>
            <Stack gap={theme.spacing(1)} flexDirection="row" alignItems={"center"} justifyContent={"center"}>
                <Typography variant={"h3"}>{t("actionPlan.activeActions")}</Typography>
                <Typography variant={"huge"}>{"-"}</Typography>
                <Typography variant={"huge"}>
                    {`${actionPlanStats.engagedActions} / ${actionPlanStats.total}`}
                </Typography>
                {/* <Button
                    variant="ternary"
                    startIcon={<FoodsIcon size={2} icon={"filter"} />}
                >
                    <Typography variant={"body-medium"}>
                        {"Filtrer"}
                    </Typography>
                </Button> */}
            </Stack>
            <HeaderActions isEdit={isEdit} toggleEdit={toggleEdit} />
        </Fragment>
    );
};

type NoItemsHeaderProps = {
    isEdit: boolean;
    toggleEdit: () => void;
};
const NoItemsHeader = (props: NoItemsHeaderProps) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const { actionPlanStats } = useActionsContext();
    const { isEdit, toggleEdit } = props;

    return (
        <Fragment>
            <Stack gap={theme.spacing(1)} flexDirection="row" alignItems={"center"} justifyContent={"center"}>
                <Typography variant={"h3"}>{t("actionPlan.activeActions")}</Typography>
                <Typography variant={"huge"}>{"-"}</Typography>
                <Typography variant={"huge"}>{`${actionPlanStats.engagedActions}`}</Typography>
            </Stack>
            {isEdit && (
                <Button variant="validate" startIcon={<FoodsIcon size={2} icon={"check"} />} onClick={toggleEdit}>
                    <Typography variant={"body-medium"} color={"inherit"}>
                        {t("action-plan.list.confirm")}
                    </Typography>
                </Button>
            )}
        </Fragment>
    );
};
